export class NewPicVersionData {
  name: string;
  mediaId: string;

  constructor({ name, mediaId }: Partial<NewPicVersionData> = {}) {
    this.name = name;
    this.mediaId = mediaId;
  }
}
